import { keepPreviousData, useQuery } from "@tanstack/react-query"

import type { FinanceInvestigationKind } from "@ibada/shared-types/finance"

import {
  financeInvestigationApi,
  type FinanceInvestigationEventsParams,
} from "@/features/finance/services/finance-investigation-api"

import { financeQueryKeys } from "@/features/finance/services/finance-query-keys"

const FINANCE_INVESTIGATION_KEY = financeQueryKeys.investigation()

export function useFinanceInvestigationEventsQuery(params: FinanceInvestigationEventsParams | null) {
  return useQuery({
    queryKey: [...FINANCE_INVESTIGATION_KEY, "events", params],
    queryFn: () => financeInvestigationApi.getEvents(params as FinanceInvestigationEventsParams),
    enabled: Boolean(params?.workspaceId),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  })
}

export function useFinanceInvestigationDetailQuery(
  kind: FinanceInvestigationKind | string | null,
  id: string | null,
  workspaceId: string | null,
) {
  return useQuery({
    queryKey: [...FINANCE_INVESTIGATION_KEY, "detail", kind, id, workspaceId],
    queryFn: () => financeInvestigationApi.getDetail(kind as string, id as string, workspaceId as string),
    enabled: Boolean(kind && id && workspaceId),
    staleTime: 30_000,
  })
}

export function useFinanceInvestigationSignalsQuery(
  params: { workspaceId: string; branchId?: string; scope?: "BRANCH" | "PARISH" } | null,
) {
  return useQuery({
    queryKey: [...FINANCE_INVESTIGATION_KEY, "signals", params],
    queryFn: () => financeInvestigationApi.getSignals(params as { workspaceId: string; branchId?: string }),
    enabled: Boolean(params?.workspaceId),
    staleTime: 60_000,
  })
}
